import React from 'react';
import { TagProps } from './tag';

export const TagContext = React.createContext<{ size: TagProps['size'] } | undefined>(undefined);

export function useTagContext() {
  const context = React.use(TagContext);

  if (!context) {
    throw new Error('This component must be used as a child of Tag component');
  }
  return context;
}
